import Utils from "./Utils";
import Player from "../Models/Player";
import Constant from "./Constant";

export default class PingTool {
    static getColorByNum(num:number){
        let s_nums = [600,350,200,100];
        let s_nums_color = ['#f40000','#f40000', '#F0C02A','#25ef68'];
        let index = 0;
        for (let i = 0; i < s_nums.length; i++) {
            if (num < s_nums[i]) {
                index = i;
            }
        }
        let progressArr = ["(一般)","(一般)","(流畅)","(极速)"];
        let color : cc.Color = cc.Color.BLACK;
        color.fromHEX(s_nums_color[index]);
        let progress = progressArr[index];
        return [color,progress,index];
    }


    static checkHttpLatency(address: string):Promise<number> {
        return new Promise(resolve => {
            let url = address + "/imsbase" + Constant.CheckSignalAPI;
            const req = new XMLHttpRequest();
            const timerStart = new Date().getTime();
            req.timeout = 2000;
            req.onerror = (e) =>{
                resolve(999)
            };
            req.onreadystatechange = (e)=>{
                if (req.readyState == 4) {
                    if(req.status == 200){
                        if(!cc.sys.isNative)
                            req.abort();
                        let num = new Date().getTime() - timerStart;
                        resolve(num > 999 ? 999 : num);
                    }else{
                        resolve(999);
                    }
                }
            }
            try {
                req.open('GET', url);
                req.setRequestHeader("Content-Type", "application/json")
                req.send();
            } catch (error) {
                console.log("====checkHttpLatency错误");
                console.log(error);

            }
            
        })
    }


}
